class ApiError extends Error {
  status: number

  type: string

  params?: any

  constructor(message: string, status: number, type: string, params?: any) {
    super(message)
    this.status = status
    this.type = type
    this.params = params
  }
}

export { ApiError }
